import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipPanelComponent} from './tooltip-panel.component';

@NgModule({
  declarations: [TooltipPanelComponent],
  imports: [CommonModule],
  exports: [TooltipPanelComponent],
})
export class TooltipPanelModule {}
